<template>
  <div class="login-container">
    <!-- 登录框 -->
    <div class="login-box">
      <div class="logo-section">
        <div class="logo-icon">
          <i class="el-icon-position"></i>
        </div>
        <h2 class="login-title">
          IP归属地查询管理系统
        </h2>
        <p class="subtitle">
          IP Location Management System
        </p>
      </div>
      
      <el-form :model="loginForm" :rules="rules" ref="loginForm" class="login-form">
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            placeholder="请输入用户名"
            prefix-icon="el-icon-user"
            size="large"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            size="large"
            @keyup.enter.native="handleLogin"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :loading="loading"
            @click="handleLogin"
            class="login-btn"
            size="large"
          >
            <span v-if="!loading">登录</span>
            <span v-else>登录中...</span>
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            const { data } = await this.$axios.post('/auth/login', this.loginForm)
            if (data.code === 200) {
              this.$store.dispatch('login', {
                token: data.data.token,
                user: {
                  username: data.data.username,
                  nickname: data.data.nickname
                }
              })
              this.$message.success('登录成功')
              this.$router.push('/dashboard')
            } else {
              this.$message.error(data.message)
            }
          } catch (error) {
            this.$message.error('登录失败，请检查用户名和密码')
          } finally {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f0f2f5;
  position: relative;
}

/* 登录框 */
.login-box {
  width: 450px;
  padding: 50px 45px;
  background: #ffffff;
  border-radius: 4px;
  position: relative;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.logo-section {
  text-align: center;
  margin-bottom: 40px;
}

.logo-icon {
  width: 100px;
  height: 100px;
  margin: 0 auto 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-icon i {
  font-size: 50px;
  color: #409EFF;
}

.login-title {
  margin: 0 0 10px 0;
  font-size: 28px;
  font-weight: 700;
  color: #303133;
}

.subtitle {
  margin: 0;
  color: #909399;
  font-size: 14px;
  font-weight: 400;
}

.login-form {
  margin-top: 30px;
}

.login-form >>> .el-form-item {
  margin-bottom: 25px;
}

.login-btn {
  width: 100%;
  height: 50px;
  margin-top: 10px;
  font-size: 16px;
  font-weight: 500;
}
</style>
